require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./lesson-two-scope-and-responsibilities.json") })
        }
      }, "path---lesson-two-scope-and-responsibilities");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---lesson-two-scope-and-responsibilities!./.cache/json/lesson-two-scope-and-responsibilities.json
// module id = 375
// module chunks = 231608221292675